module.exports = __webpack_public_path__ + "static/Step 4-72ca8a3a988de0bde7f96f217aa78f57.png";